import { PageSize } from '@/constant';
import { GetWorkerHistoryListParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

import { RootState } from '..';
import { storage } from '../store.persist';
import {
	IPayloadGetWorkerHistoryListRequest,
	IPayloadGetWorkerHistoryListSuccess,
	IWorkerHistoryDetailStore,
} from './worker-history.type';

const InitParams: GetWorkerHistoryListParams = {
	page: 1,
	pageSize: PageSize.S,
};

const initialState = {
	fetching: false,
	list: [] as IWorkerHistoryDetailStore[],
	total: 0,
	params: InitParams,
};

const workerHistorySlice = createSlice({
	initialState,
	name: 'workerHistory',
	reducers: {
		/**---- GET WORKER HISTORY LIST START ---- */
		getWorkerHistoryListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerHistoryListRequest>
		) => {
			return {
				...state,
				fetching: true,
				params: action?.payload,
			};
		},
		getWorkerHistoryListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerHistoryListSuccess>
		) => {
			const { content, total } = action.payload;
			state.fetching = false;
			state.list = content;
			state.total = total;
		},
		getWorkerHistoryListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.list = [];
		},
		/**---- GET WORKER HISTORY LIST END ---- */
	},
});

export const WorkerHistorySelectors = {
	selectFetching: (state: RootState) => state.workerHistory.fetching,
	selectParams: (state: RootState) => state.workerHistory.params,
	selectList: (state: RootState) => state.workerHistory.list,
	selectTotal: (state: RootState) => state.workerHistory.total,
};

export const WorkerHistoryActions = workerHistorySlice.actions;

export const WORKER_HISTORY_PERSIST_KEY = 'workerHistoryPersist';
export const WorkerHistoryReducer = persistReducer(
	{
		key: WORKER_HISTORY_PERSIST_KEY,
		storage,
		whitelist: ['params'],
	},
	workerHistorySlice.reducer
);
